import styled from "@emotion/styled";

export const FooterTable = styled.table({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",

    td: {
        padding: "0 5px",
    },
});

export const FooterRoot = styled.div<{ marginLeft: string | number }>(props => ({
    paddingTop: 5,
    paddingBottom: 35,
    marginLeft: props.marginLeft,
}));
